import { GroupName } from "src/app/services/openApi";
import { isNil } from "lodash";

export const getGroupName = (groupSerial: number | undefined, groupsNames: GroupName[]) => {
  if (!groupsNames || isNil(groupSerial)) return "ללא קבוצה";
  const group = groupsNames.find((group) => group.serial === groupSerial);
  const groupName = group ? group.nickname : "";
  return groupName;
};
